module.exports = __webpack_public_path__ + "img/20.45ba763f.webp";